// eslint-disable-next-line import/prefer-default-export
export const settingTypeMap = {
  switch: 'dark',
  number: 'dark',
  text: 'dark',
  description: 'dark',
}
